#import "../fragments/wf-field-fragment.graphql"

fragment WfFormStubFragment on Form {
    id
    name
    status
    htmlUrlPath
    numSubmissions
    numMappedFields
    lastSubmittedTime
    publishedVersion {
        id
        fields {
            ...WfFieldFragment
        }
    }
}
